import React, { Component } from "react";
class HowDepositMoney extends Component {
  render() {
    return (
      <>
        {this.props.content.edges && (
          <div id="how-deposit-money" className="bg-light-grey">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 offset-lg-3">
                  <div
                    className="media"
                    data-sal="slide-up"
                    data-sal-duration="400"
                    data-sal-easing="ease-in-quad"
                  >
                    <img
                      src={this.props.iconInfo.publicURL}
                      className="mr-5"
                      alt="Info"
                    />
                    <div className="media-body">
                      <h2
                        className="mt-0"
                        dangerouslySetInnerHTML={{
                          __html:
                            this.props.content.edges[0].node.acfPartials
                              .pHeading,
                        }}
                      />
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            this.props.content.edges[0].node.acfPartials
                              .pContent,
                        }}
                      />
                      <div className="my-5">
                        <div className="button-div">
                          <a
                            className="button button-primary"
                            href={
                              this.props.content.edges[0].node.acfPartials
                                .pButtonUrl
                            }
                            rel="noreferrer noopener"
                          >
                            {
                              this.props.content.edges[0].node.acfPartials
                                .pButtonText
                            }
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default HowDepositMoney;
